// **********************************************************************
//
// VideoTrack
//
// A HTML Video Element Track
//
// **********************************************************************

import MediaElementTrack from './MediaElementTrack'
import enableInlineVideo from 'iphone-inline-video'

const defaultAttr = {
  playsinline: true,
  preload: 'none',
  muted: true,
  poster: null,
  crossorigin: 'anonymous',
  'x5-video-player-type': 'h5',
  'x5-video-player-fullscreen': 'true',
  'x5-video-player-orientation': 'portrait',
}

class VideoTrack extends MediaElementTrack {
  constructor(trackConfig) {
    defaultAttr['webkit-playsinline'] =
      trackConfig.playsinline || defaultAttr.playsinline
    super(trackConfig, 'video', defaultAttr)
  }

  onLoaded = () => {
    enableInlineVideo(this.el)
  }
}

export default VideoTrack
